import { api } from '../../App'

export const sendOrderStatus = data => {
  const { restid, id } = data

  return api.put(`https://api.menu-rest.com/api/v1/order/${restid}/orderrow/${id}/finished`)
}
